import React, { useState, useEffect } from "react";
import "./PlacementsUpload.css";
import { resources } from "../Resourses/Resources"; 
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 
import axios from "axios";

const successMessage = (message) => {
  toast.success(message, {
    position: "top-center", 
    toastId: "success1",
  });
};

const errorMessage = (message) => {
  toast.error(message, {
    position: "top-center", 
  });
};

function PlacementsUpload() {
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(""); 
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const years = [];
    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= currentYear - 13; i--) {
      years.push(`${i}-${i + 1}`);
    }
    setAcademicYears(years);
  }, []);

  const handleSelectFile = (e) => {
    setFile(e.target.files[0]);
  };

  const handleReset = () => {
    setFile(null);
    document.getElementById("placements-studentExcel").value = "";
    setSelectedYear("");
  };

  const handleSubmit = async () => {
    if (!selectedYear) {
      errorMessage("Please select an Academic Year.");
      return;
    }
    if (!file) {
      errorMessage("Please select a file before uploading.");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("academicYear", selectedYear);

      const response = await axios.post(
        `${resources.APPLICATION_URL}PlacementCell/exceupload`,
        formData,
      );

      if (response.status === 200) {
        successMessage(response.data);
        handleReset();
      } else {
        errorMessage("Upload failed. Please try again.");
      }
    } catch (error) {
      console.error(error);
      errorMessage("Error while uploading. Please check the server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="placements-container">
      <h2 className="placements-title">Placements Upload</h2>

      <div className="placements-form-group">
        <label className="placements-label">Academic Year</label>
        <select
          className="placements-select"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
        >
          <option value="">Please Select Academic Year</option>
          {academicYears.map((year, index) => (          
            <option key={index} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      <div className="placements-file-section">
        <div className="placements-file-input">
          <input
            type="file"
            id="placements-studentExcel"
            accept=".xlsx,.xls"
            onChange={handleSelectFile}
            style={{ color: "black" }}
          />
        </div>
        {selectedYear && file && (
          <div className="placements-buttons">
            <button className="placements-btn placements-btn-reset" onClick={handleReset}>
              Reset
            </button>
            <button
              className="placements-btn placements-btn-upload"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Uploading..." : "Upload"}
            </button>
          </div>
        )}
      </div>

      <div className="placements-download">
        <a
          className="placements-link"
          href={`${resources.APPLICATION_URL}getPlacementCellTemplate`}
          download
        >
          Download Template
        </a>
      </div>

      {loading && (
        <div className="placements-loader-overlay">
          <div className="placements-loader"></div>
          <p>Uploading, please wait...</p>
        </div>
      )}

      <ToastContainer />
    </div>
  );
}

export default PlacementsUpload;
